import _ from '@lodash'
import {
  FilledInput,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from '@material-ui/core'
import CountryRegionData from 'country-region-data'
import { withFormsy } from 'formsy-react'
import * as R from 'ramda'
import React from 'react'
import { usePrevious } from '@fuse/hooks'
import { FormattedMessage } from 'react-intl'

function StateSelectorFormsy({ country, ...props }) {
  const getRegionOptionsByCountryName = (countryCode) => {
    const country = R.find(
      R.propEq('countryShortCode', countryCode),
      CountryRegionData,
    )
    return R.propOr([], 'regions', country)
  }

  const importedProps = _.pick(props, [
    'autoWidth',
    'children',
    'classes',
    'displayEmpty',
    'input',
    'inputProps',
    'MenuProps',
    'multiple',
    'native',
    'onChange',
    'onClose',
    'onOpen',
    'open',
    'renderValue',
    'SelectDisplayProps',
    'value',
    'variant',
  ])
  const FormControlProps = R.prop('FormControlProps')(props)

  // An error message is returned only if the component is invalid
  const errorMessage = props.errorMessage
  const value = props.value
  const previousValue = usePrevious(value)
  function input() {
    switch (importedProps.variant) {
      case 'outlined':
        return (
          <OutlinedInput labelWidth={props.label.length * 8} id={props.name} />
        )
      case 'filled':
        return <FilledInput id={props.name} />
      default:
        return <Input id={props.name} />
    }
  }

  React.useEffect(() => {
    if (value && previousValue && value !== previousValue) {
      props.setValue('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country])

  function changeValue(event) {
    const oldValue = props.value
    if (!R.equals(oldValue, event.target.value)) {
      props.setValue(event.target.value)
    }
  }

  const shouldShowErrorMsg = Boolean(errorMessage) && !props.isPristine

  return (
    <FormControl
      error={shouldShowErrorMsg}
      className={props.className}
      variant={importedProps.variant}
      required={props.required}
      {...FormControlProps}
    >
      {props.label && (
        <InputLabel htmlFor={props.name}>{props.label}</InputLabel>
      )}
      <Select
        {...importedProps}
        onChange={changeValue}
        input={input()}
        value={value}
      >
        {R.compose(
          R.ifElse(
            R.isEmpty,
            () => {
              return (
                <Typography className="p-16">
                  <FormattedMessage id="planAndBilling.billingDetails.form.state.empty.label" />
                </Typography>
              )
            },
            R.map((option) => {
              return (
                <MenuItem key={option.name} value={option.name}>
                  {option.name}
                </MenuItem>
              )
            }),
          ),
          getRegionOptionsByCountryName,
        )(country)}
      </Select>
      {shouldShowErrorMsg && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  )
}

export default React.memo(withFormsy(StateSelectorFormsy))
